// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 6672 ? "a47a95e9" : chunkId) + "." + {"1057":"aeaf9a74e520aafc","5918":"a1ff8aaa6d390ca0","6144":"53371bdf1bf56346","6404":"dcd0caa963122d7b","6672":"8f9a155b1c45ac86"}[chunkId] + ".js";
};